import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { SelfDigitalWorkingHoursScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-working-hours-score.aggregate-root';
import { GetSelfDigitalWorkingHoursScoreResponseDto } from '../../../interface/dtos/scores/self-get-digital-working-hours-scores.response.dto';

export type ISelfDigitalWorkingHoursScoreAggregateRootMapper = Mapper<
  SelfDigitalWorkingHoursScoreAggregateRoot,
  GetSelfDigitalWorkingHoursScoreResponseDto
>;

export class SelfDigitalWorkingHoursScoreAggregateRootMapper
  implements Omit<ISelfDigitalWorkingHoursScoreAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfDigitalWorkingHoursScoreAggregateRoot
  ): GetSelfDigitalWorkingHoursScoreResponseDto {
    return SelfDigitalWorkingHoursScoreAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfDigitalWorkingHoursScoreAggregateRoot
  ): GetSelfDigitalWorkingHoursScoreResponseDto {
    return {
      value: formatDuration(entity.thisPeriodWorkingHoursScore),
      unformattedValue: entity.thisPeriodWorkingHoursScore,
      allTimeAverage: formatDuration(entity.allTimeAverageWorkingHoursScore),
      max: formatDuration(entity.allTimeMaxWorkingHoursScore),
      deviationFromAveragePercentage: formatDeviation(
        entity.deviationFromAvereagePercentage
      ),
      name: entity.name,
    };
  }
}
